
export default {
  name: 'TutorialFullWidthBannerSection',
  props: {
    data: {
      type: Object,
      default: () => ({
        ButtonText: '查看更多',
        ButtonLink: 'https://google.com',
        mode: '1'
      }),
    },
  },
  data() {
    return { 
      activeItemId: 0,
      backgroundImg: 'cross-selling-banner-tutorial.png'
    }
  },
  computed: {  
    backgroundImageInlineStyle () {
      // return `background-image: url("./assets/images/${this.backgroundImg}");`;

      const bgImage = require(`@/assets/images/${this.backgroundImg}`)
      return `background-image: url( ${bgImage} ); `;
    },
    backgroundImageInlineStyle2 () {
      // return `background-image: url("./assets/images/${this.backgroundImg}");`;

      const bgImage = require(`@/assets/images/${this.backgroundImg}`)
      return `background-image: url( ${bgImage} ); `;
    }
  },
  methods: {
    toggleActiveItem(i) {
      if (i === this.activeItemId) {
        this.activeItemId = -1
      } else {
        this.setActiveItem(i)
      }
    },

    setActiveItem(i) {
      this.activeItemId = i
    }
  },
}
